import { PocButton } from 'commons/components/components-wrapper';
import { owcTheme } from 'core/theme/theme.config';
import styled, { css } from 'styled-components';

// Single source of truth for the bulk-action button look (icon stacked above text = the v6 square
// layout whose hover fills the bulk bar height). Shared by BOTH the `BulkActionButtonComponent`
// (below) and the legacy `.bulk-action` class in bulk-actions.style.ts, so a future @one owc-button
// fix only has to be applied here once instead of being duplicated across both implementations.
export const bulkActionButtonContentStyles = css`
    color: ${owcTheme['one-color-interaction-default-intensity-medium']} !important;

    /* OWC-OVERRIDE: stack the icon above the label so the bulk-action button keeps its v6
       square shape and its hover fills the bulk bar height.
       owc-button adds a 3-class scoped rule (.sc-owc-button-h .owc-button__content-wrapper.sc-owc-button)
       forcing flex-direction: row in v7.6.0, which outweighs this selector; there is no
       icon-placement or vertical prop, so !important is required. Revisit on the next @one upgrade. */
    .owc-button__content-wrapper {
        display: flex;
        flex-direction: column !important;
    }

    owc-icon {
        margin-right: unset !important;
        font-size: 24px !important;
    }
`;

export const BulkActionButtonLayout = styled.div`
    position: relative;

    > owc-list {
        position: absolute;
        top: -109px;
        width: 142px;
        max-width: 142px;
        border: solid 1px ${owcTheme['one-color-gray-100']};

        owc-list-item {
            width: 140px;
        }
    }

    .search-button {
        width: 100%;
    }
`;

export const BulkActionButtonStyled = styled(PocButton)`
    ${bulkActionButtonContentStyles}

    &.disabled {
        color: ${owcTheme['one-color-interaction-disabled-base']};
    }
`;
